<template>
  <document-section
    :class="{ 'max-height': getIfShowVeil }"
    tag="div"
  >
    <div
      v-show="getIfShowVeil"
      data-test-id="veil"
      class="black-veil"
    />
    <WelcomeRegisteredUserComponent
      v-if="hasToShowRegisterUserOnboarding"
      :current-route="$route.path"
      :current-user="currentUser"
    />
    <WelcomePromoUserComponent
      v-else-if="hasToShowPromoUserOnboarding"
      :current-route="$route.path"
      :current-user="currentUser"
    />

    <v-navigation-drawer
      v-if="hasToRenderNavigationDrawer"
      id="app-drawer"
      v-model="drawer"
      color="var(--v-card-base)"
      width="280px"
      app
      touchless
      class="shadow-sidebar sidebar-border px-1"
      :permanent="$breakpoint.isSidebarFixed"
    >
      <v-list-item id="logo-container">
        <v-list-item-content class="pt-7">
          <v-list-item-title class="title d-flex justify-space-between">
            <LogoMenuComponent
              :id="'673_11252'"
              :key="2"
              class="clickable"
              :has-custom-size-for-mobile="false"
            />
            <ph-x
              v-if="$vuetify.breakpoint.mdAndDown"
              color="var(--v-grey-darken4)"
              :size="28"
              weight="thin"
              @click="drawer = !drawer"
            />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list
        :class="{
          'mt-3': $breakpoint.tabletAndUp,
        }"
        nav
        dense
      >
        <!-- guest user menu options -->
        <v-list-item-group
          color="primary"
          active-class="list-item-group-active"
        >
          <!-- Guest user menu options -->
          <v-list-item
            class="no-border-radius pr-3 menu-item mb-0"
            to="/"
          >
            <v-list-item-icon class="mr-2 mt-4">
              <ph-newspaper
                color="var(--v-primary-base)"
                :size="24"
                weight="light"
              />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                class="text text-m-large-regular grey--text text--darken-4"
                @click="handleClickFeedAsGuestUser"
              >
                Feed
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isEnabledPremiumCourses"
            class="no-border-radius pr-3 menu-item mb-0 mt-0"
            to="/premium-courses"
            @click="handleClickPremiumCoursesAsGuestUser"
          >
            <v-list-item-icon class="mr-2 mt-4">
              <ph-book-bookmark
                color="var(--v-primary-base)"
                :size="24"
                weight="light"
              />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                class="d-flex justify-space-between align-center text-m-large-regular text grey--text text--darken-4"
                style="white-space: normal"
              >
                FluoroSafety
                <v-chip
                  class="text text-m-small-regular pro-chip-special-requirements"
                  color="#FFAB18"
                  dark
                  label
                >
                  <CrownFilledIconComponent
                    class="mr-1"
                    :size="14"
                  />
                  Pro
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            class="no-border-radius pr-3 menu-item mb-0 mt-0"
            to="/special-requirements"
          >
            <v-list-item-icon class="mr-2 mt-4">
              <ph-clipboard-text
                color="var(--v-primary-base)"
                :size="24"
                weight="light"
              />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                class="d-flex align-center justify-space-between text text-m-large-regular grey--text text--darken-4"
                style="white-space: normal"
              >
                Special requirements
                <v-chip
                  v-if="hasToShowProBadge"
                  class="text text-m-small-regular pro-chip-special-requirements"
                  color="#FFAB18"
                  dark
                  label
                >
                  <CrownFilledIconComponent
                    class="mr-1"
                    :size="14"
                  />
                  Pro
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <v-list-group v-if="currentUser">
          <template #activator>
            <v-list-item class="menu-item mb-0 pl-0">
              <v-list-item-icon class="mr-2 mt-4">
                <ph-student
                  color="var(--v-primary-base)"
                  :size="24"
                  weight="light"
                />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="d-flex text text-m-large-regular justify-space-between grey--text text--darken-4"
                >
                  Account
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(item, i) in menuItemOptions.slice(2)"
            :key="i"
            :class="[
              {
                'primary-surface': checkIfMenuIsActive(item),
              },
            ]"
            class="no-border-radius pl-10 menu-item mb-0"
            @click="menuAction(item.id)"
          >
            <v-list-item-icon class="mr-2 mt-4">
              <ph-trophy
                v-if="item.text === 'Transcript'"
                color="var(--v-primary-base)"
                :size="24"
                weight="light"
              />
              <ph-rocket
                v-if="item.text === 'My Plan'"
                color="var(--v-primary-base)"
                :size="24"
                weight="light"
              />
              <ph-warning
                v-if="hasIncompleteProfile && item.text === 'Profile'"
                color="var(--v-warning-base)"
                :size="24"
                weight="light"
              />
              <ph-user-circle
                v-else-if="item.text === 'Profile'"
                color="var(--v-primary-base)"
                :size="24"
                weight="light"
              />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-if="hasIncompleteProfile && item.text === 'Profile'"
                class="d-flex text text-m-large-regular justify-space-between warning--text"
              >
                Complete profile
              </v-list-item-title>
              <v-list-item-title v-else-if="item.text === 'Premium Courses'">
                FluoroSafety
              </v-list-item-title>
              <v-list-item-title
                v-else
                class="d-flex text text-m-large-regular justify-space-between grey--text text--darken-4"
              >
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <v-list
        v-if="!hasToFixBottomHelpLinks"
        class="px-0"
        nav
      >
        <!-- Scrolleable bottom section -->
        <v-list-item-group color="primary">
          <BottomLinksSectionComponent
            :current-user="currentUser"
            class="mt-7"
          />
        </v-list-item-group>
      </v-list>
      <template
        v-if="hasToFixBottomHelpLinks"
        #append
      >
        <v-list-item-group color="primary">
          <BottomLinksSectionComponent :current-user="currentUser" />
        </v-list-item-group>
      </template>
    </v-navigation-drawer>
    <v-app-bar
      v-if="shouldShowTopBar"
      app
      class="app-bar"
      :height="$breakpoint.tabletAndUp ? '60px' : '56px'"
      :color="navBarBackground"
      flat
    >
      <v-app-bar-nav-icon
        v-if="hasToRenderNavigationDrawer"
        class="d-inline d-lg-none"
        data-test-id="menu-drawer-btn"
        @click="drawer = !drawer"
      >
        <ph-list
          color="var(--v-grey-darken1)"
          :size="32"
          weight="thin"
        />
      </v-app-bar-nav-icon>

      <div
        v-if="!hasToShowBackNavigation && $route.name === 'home' && $vuetify.breakpoint.mdAndDown"
        class="d-block mr-auto mx-lg-0 clickable"
        @click="menuAction(0)"
      >
        <LogoMenuComponent
          :id="'673_11253'"
          :key="1"
          :is-auditor="isAuditor"
        />
      </div>
      <!-- only for PDF and Content view orphan routing -->
      <div
        v-if="
          !hasToShowBackNavigation &&
          ($route.name === 'article-file-view' ||
            $route.name === 'article-disclosure-pdf' ||
            $route.name === 'course-disclosure-pdf' ||
            $route.name === 'course-module-content-preview' ||
            $route.name === 'auditor-article-file-view')
        "
        class="d-block mr-auto mx-lg-0 clickable"
        @click="menuAction(0)"
      >
        <LogoMenuComponent
          :id="'673_11254'"
          :key="2"
        />
      </div>
      <div
        v-if="hasToShowBackNavigation"
        class="d-flex container-back"
      >
        <ph-caret-left
          v-show="getTitle"
          class="clickable"
          weight="thin"
          size="24"
          color="var(--v-grey-darken4)"
          @click="goBack"
        />
        <h6
          class="text text-l-large-regular grey--text text--darken-3 ml-2 clickable"
          :class="{ 'text-truncate fixed-back-text': $breakpoint.mobileAndDown }"
          @click="goBack"
        >
          {{ getTitle }}
        </h6>
      </div>
      <v-spacer class="d-block" />
      <AvatarBadgeComponent
        :has-to-show-unawarded-badge="hasToShowUnawardedBadge"
        :awarded-credits-to-show="awardedCreditsToShow"
        :full-name="fullName"
        :is-auditor="isAuditor"
        :has-to-disabled-quiz-button="getTakeQuizButtonDisabledInNavBar"
        @go-to-login="goToLogin"
        @go-to-signup="goToSignup"
      />
    </v-app-bar>
    <v-main :class="[getIfShowVeil || (!currentUser && isFeedRoute) ? 'pt-0' : 'pt-14 pt-sm-15', layoutMain]">
      <CompleteProfileAlert @show-complete-profile-dialog="showCompleteProfileDialog" />
      <CompleteProfileDialog
        v-if="
          shouldShowCompleteProfileDialog ||
          shouldShowCompleteProfileDialogOnTranscript ||
          shouldShowCompleteProfileDialogOnProfile
        "
        @on-close="hideCompleteProfileDialog"
      />
      <FreeTrialReachedLimitsAlert v-if="!hasIncompleteProfile" />
      <premium-alert v-if="!hasIncompleteProfile"></premium-alert>
      <!-- TODO: delete this components if they are not being used anymore -->
      <special-requirements-alert v-if="currentUser" />
      <header
        id="headerBanner"
        :class="{ 'pt-14 pt-sm-15 pt-md-15 pt-lg-0': !currentUser && isFeedRoute }"
      >
        <WrapperBannersComponent v-if="!currentUser && isFeedRoute" />
      </header>
      <v-container :class="[layoutBackground, { 'container-full-width': hasToApplyFullWidth }]">
        <!-- TODO: see if this is working as it should -->
        <v-row
          v-if="showExpirationAlert"
          no-gutters
          justify-sm="center"
        >
          <v-col
            class="px-sm-11 px-lg-0 px-6"
            :class="{
              'mb-4': !hasToApplyFullWidth,
            }"
            cols="12"
            sm="12"
            lg="12"
          >
            <ExpirationAlertCardComponent :finish-init-load="finishInitLoad" />
          </v-col>
        </v-row>
        <v-row
          no-gutters
          :class="[{ 'center-content-update-card': hasToCenterContentToUpdateCard }]"
          justify-sm="center"
        >
          <v-col
            class="px-sm-12 px-lg-0 px-6"
            :class="{
              'mb-4': !hasToApplyFullWidth,
              'px-md-11': isMainFeedRoute,
            }"
            cols="12"
            sm="12"
            lg="12"
          >
            <slot name="content" />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <!-- TODO: remove everything related to pretest -->
    <!-- Show pretest -->
    <div
      v-if="isShowingPretestOnboarding && !isAuditor"
      ref="onboardingPanelDisclosure"
      class="onboarding-pretest-panel onboarding-pretest-panel-size border-radius-small d-flex"
    >
      <v-row
        no-gutters
        class="justify-space-around fix-last-step-overflow pa-6 pt-0 pa-sm-10 mb-0 pt-small-mobile"
        :class="[
          { 'align-content-start': $vuetify.breakpoint.xsOnly },
          { 'no-overflow-y': $vuetify.breakpoint.smAndUp },
        ]"
      >
        <v-col
          class="col-12 col-sm-4 col-md-3 col-lg-auto text-center mb-n11 mb-sm-n1"
          :class="{ 'adjust-images': $vuetify.breakpoint.smAndUp }"
        >
          <PretestImagesHandlerComponent
            :current-step-index="currentStepIndex"
            :items="items"
          />
        </v-col>
        <v-col
          class="right-side-onboarding step-container col-12 col-sm-8 col-md-9 col-lg pl-sm-4 py-0 pr-sm-1 text-container"
          :class="[
            { 'pt-13': $vuetify.breakpoint.xsOnly },
            { 'pt-md-8': $vuetify.breakpoint.mdAndUp && currentStepIndex === enumOnboarding.THIRD_STEP },
          ]"
        >
          <v-row
            no-gutters
            align="center"
          >
            <h3
              v-show="$breakpoint.mobileAndUp"
              class="heading primary--text"
              :class="calculateClassForTitle"
            >
              {{ titleForSteps }}
            </h3>
          </v-row>
          <v-row no-gutters>
            <p
              ref="descriptions"
              class="descriptions mb-0 text text-l-large-regular word-wrap-all"
              :class="[
                {
                  'mb-10': $vuetify.breakpoint.width === 768 && currentStepIndex == enumOnboarding.THIRD_STEP,
                  'first-step-nonmobile': currentStepIndex === enumOnboarding.INTRO_INITIAL_STEP,
                  'second-step-nonmobile': currentStepIndex === enumOnboarding.SECOND_STEP,
                },
                { 'pt-sm-2': $vuetify.breakpoint.smAndUp && currentStepIndex == enumOnboarding.THIRD_STEP },
              ]"
              v-html="items[currentStepIndex].desc"
            />

            <v-checkbox
              v-show="currentStepIndex === enumOnboarding.SECOND_STEP"
              v-model="noShowOnboarding"
              :value="true"
              class="mt-0 mt-2 pt-3 mt-sm-0 mt-md-0 pt-md-4 pt-lg-4 no-show-again"
            >
              <template #label>
                <div>
                  <span class="text text-l-small-regular">Don't show me this message again</span>
                </div>
              </template>
            </v-checkbox>
          </v-row>

          <v-row
            no-gutters
            class="mt-sm-0 pl-sm-3 stepButtoms"
            justify-sm="space-between"
            :class="[
              {
                'fixed-bottom-mobile': $vuetify.breakpoint.xsOnly,
                'fixed-actions-nonmobile': !$vuetify.breakpoint.xsOnly,
              },
            ]"
          >
            <v-col
              v-show="!$vuetify.breakpoint.xsOnly"
              cols="12"
              sm="auto"
              align-self="center"
            >
              <div class="d-flex">
                <DotComponent
                  v-for="index in 2"
                  v-show="currentStepIndex !== enumOnboarding.THIRD_STEP"
                  :key="index"
                  :index="index - 1"
                  :current-step-index="currentStepIndex"
                  class="clickable"
                  @clicked="goToStep(index - 1)"
                />
              </div>
            </v-col>
            <v-col
              class="col-12 text-right align-self-center col-sm-auto"
              :class="{ 'buttons-disposition-mobile': $vuetify.breakpoint.xsOnly }"
            >
              <v-btn
                v-show="
                  currentStepIndex === enumOnboarding.SECOND_STEP || currentStepIndex === enumOnboarding.THIRD_STEP
                "
                ripple
                depressed
                :block="$vuetify.breakpoint.xsOnly"
                :height="$vuetify.breakpoint.xsOnly ? '44px' : '36px'"
                :color="$vuetify.breakpoint.xsOnly ? 'grey lighten-5' : ''"
                class="primary--text heading heading-s-small align-self-center unaltered-text-cap shadow-light-button mr-sm-4"
                @click="skipOnboarding"
              >
                {{ getSecondaryButtonText() }}
              </v-btn>
              <v-btn
                ripple
                depressed
                :block="$vuetify.breakpoint.xsOnly"
                :height="$vuetify.breakpoint.xsOnly ? '44px' : '36px'"
                color="primary white--text heading heading-s-small align-self-center unaltered-text-cap mr-sm-0"
                class="heading heading-s-small align-self-center unaltered-text-cap shadow-light-button px-6 mb-4 mb-sm-0"
                @click="nextStep"
              >
                {{ getPrimaryButtonText() }}
              </v-btn>
            </v-col>
            <v-col
              v-show="$vuetify.breakpoint.xsOnly"
              class="justify-center mt-2"
              :class="{ 'd-flex': currentStepIndex < enumOnboarding.SELECT_PLAN_STEP && $vuetify.breakpoint.xsOnly }"
              cols="12"
              sm="4"
              align-self="center"
            >
              <div class="d-flex">
                <DotComponent
                  v-for="index in 2"
                  v-show="currentStepIndex !== enumOnboarding.THIRD_STEP"
                  :key="index"
                  :index="index - 1"
                  :current-step-index="currentStepIndex"
                  class="clickable"
                  @clicked="goToStep(index - 1)"
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </document-section>
</template>

<script>
import WelcomeRegisteredUserComponent from '@/components/onboarding/WelcomeRegisteredUserComponent';
import WelcomePromoUserComponent from '@/components/onboarding/WelcomePromoUserComponent';
import AvatarBadgeComponent from '@/components/common/AvatarBadgeComponent';
import LogoMenuComponent from '@/assets/LogoMenuComponent';
import CrownFilledIconComponent from '@/assets/CrownFilledIconComponent';
import ExpirationAlertCardComponent from '@/components/common/ExpirationAlertCardComponent';
import SpecialRequirementsAlert from '@/components/common/SpecialRequirementsAlert.vue';
import FreeTrialReachedLimitsAlert from '@/components/common/FreeTrialReachedLimitsAlert';
import CompleteProfileAlert from '@/components/common/CompleteProfileAlert';
import { specialReqsMixin } from '@/mixins/specialReqsMixin';
import { upgradeAlertsMixin } from '@/mixins/upgradeAlertsMixin';
import { mapActions, mapGetters, mapState } from 'vuex';
import {
  PhCaretLeft,
  PhList,
  PhBookBookmark,
  PhNewspaper,
  PhTrophy,
  PhRocket,
  PhUserCircle,
  PhX,
  PhClipboardText,
  PhStudent,
  PhWarning,
} from 'phosphor-vue';
import { DocumentSection } from 'vue-headings';
import WrapperBannersComponent from '@/components/common/WrapperBannersComponent';
import BottomLinksSectionComponent from './menu/BottomLinksSectionComponent';
import PretestImagesHandlerComponent from '@/components/pretest/images/PretestImagesHandlerComponent';
import DotComponent from '@/components/common/DotComponent';
import { useUserHasSpecialRequirementInProgress } from '@/composables/special-requirements/useUserHasSpecialRequirementInProgress';
import CompleteProfileDialog from '@/components/profile/CompleteProfileDialog';
import { completeProfileAlertMixin } from '@/mixins/completeProfileAlertMixin';
import PremiumAlert from '@/components/premiumCourses/abstract/PremiumAlert';

export default {
  name: 'LayoutComponent',
  components: {
    WelcomeRegisteredUserComponent,
    DocumentSection,
    WelcomePromoUserComponent,
    AvatarBadgeComponent,
    LogoMenuComponent,
    CrownFilledIconComponent,
    PhCaretLeft,
    PhList,
    PhNewspaper,
    PhTrophy,
    PhRocket,
    PhUserCircle,
    PhBookBookmark,
    PhX,
    PhClipboardText,
    PhStudent,
    PhWarning,
    ExpirationAlertCardComponent,
    SpecialRequirementsAlert,
    WrapperBannersComponent,
    BottomLinksSectionComponent,
    PretestImagesHandlerComponent,
    DotComponent,
    FreeTrialReachedLimitsAlert,
    CompleteProfileAlert,
    CompleteProfileDialog,
    PremiumAlert,
  },
  mixins: [
    completeProfileAlertMixin,
    specialReqsMixin,
    upgradeAlertsMixin,
  ],
  setup() {
    const { userHasSpecialRequirementInProgress } = useUserHasSpecialRequirementInProgress();

    return {
      userHasSpecialRequirementInProgress,
    };
  },
  data: () => {
    const menuItemOptions = [
      { id: 0, text: 'Feed', routeName: 'home' },
      { id: 'premium-courses', text: 'Premium Courses', routeName: 'premium-courses-feed' },
      { id: 2, text: 'Transcript', routeName: 'transcripts' },
      { id: 3, text: 'My Plan', routeName: 'my-plan' },
      { id: 4, text: 'Profile', routeName: 'profile' },
    ];

    if (process.env.VUE_APP_ENABLE_PREMIUM_COURSE !== 'true') {
      const premiumCoursesMenuIndex = menuItemOptions.findIndex((item) => item.id === 'premium-courses');
      menuItemOptions.splice(premiumCoursesMenuIndex, 1);
    }

    return {
      drawer: null,
      menuItemOptions: menuItemOptions,
      layoutBackground: 'layout-container',
      layoutMain: 'layout-main',
      currentRouteName: null,
      showSpecialyListDialog: false,
      currentRoutePath: null,
      navBarBackground: 'var(--v-background-base)',
      paymentMethod: null,
      initial: 0,
      userSubscription: null,
      isFetchedUserSubscription: false,
      finishInitLoad: false,
      currentStepIndex: 0,
      items: [
        {
          id: '0',
          title: 'What is a pre-test?',
          desc: 'To ensure physicians are learning from our content, you will occasionally be asked to complete a short pre-test before viewing the article.',
          btnPrimary: 'Next',
          btnSecondary: '',
        },
        {
          id: '1',
          title: "Your pre-test score doesn't matter!",
          desc: 'After completing the pre-test you will be able to access the article and take the 5-question post-test.',
          btnPrimary: 'Start pre-test',
          btnSecondary: 'Go back to Feed',
        },
        {
          id: '2',
          title: 'Thank you!',
          desc: 'Now you can read the article, complete the post-test and get CME credit.',
          btnPrimary: 'Read article and take quiz',
          btnSecondary: 'Go back to Feed',
        },
      ],
      enumOnboarding: {
        INTRO_INITIAL_STEP: 0,
        SECOND_STEP: 1,
        THIRD_STEP: 2,
        SELECT_PLAN_STEP: 4,
      },
      noShowOnboarding: false,
      escriptionClasses: 'descriptions mb-0 text text-l-large-regular',
      mountedDone: false,
      animatedClass: 'animate-text',
      touchendX: 0,
      touchendY: 0,
      touchstartX: 0,
      touchstartY: 0,
      touchEventsDone: false,
      currentArticleId: 0,
    };
  },
  computed: {
    ...mapGetters('auth', ['currentUser', 'isAuditor']),
    ...mapGetters('profile', ['currentProfile', 'willPaymentMethodExpire', 'shouldShowCompleteProfileDialog']),
    ...mapGetters('specialRequirements', ['lastVisitedTopicState']),
    ...mapGetters('feed', [
      'isOnboardingFinished',
      'isOnboardingRequestDone',
      'isLayoutPretest',
      'isOnboardingPretestToShowAgain',
      'isOnboardingPretestShow',
      'getArticleId',
      'isShowPretestResult',
    ]),
    ...mapGetters('menu', [
      'getTitle',
      'getIfShowVeil',
      'getBackIfIsInternalRouting',
      'getCurrentReadingAtArticleId',
      'getIsReportCustom',
      'getIsReportOpen',
      'getHideAllMenu',
      'getTakeQuizButtonDisabledInNavBar',
    ]),
    ...mapGetters('subscriptions', ['hasActiveSubscription']),
    ...mapState('menu', ['hasToShowBackNavigation']),
    fullName() {
      return this.currentProfile ? `${this.currentProfile.firstName} ${this.currentProfile.lastName}` : 'N/A';
    },
    awardedCreditsToShow() {
      return this.currentUser?.awardedCredits ?? 0;
    },
    hasUnawardedCredits() {
      const totalUnawardedCredits = +(this.currentUser?.unawardedCredits ?? 0);

      return totalUnawardedCredits > 0;
    },
    hasToApplyFullWidth() {
      const hasDrawerButIsNotShown = this.isMainFeedRoute && this.$vuetify.breakpoint.mdOnly;
      const isShowingTheSpecialRequirementsSection =
        this.$breakpoint.smallDesktopAndUp && !this.userHasSpecialRequirementInProgress;
      if (hasDrawerButIsNotShown && isShowingTheSpecialRequirementsSection) return true;

      const isPdfRoute = this.currentRoutePath?.includes('pdf');
      const isContentRoute =
        this.currentRouteName === 'course-module-content' || this.currentRouteName === 'course-module-content-preview';

      return isPdfRoute || isContentRoute;
    },
    hasToShowUnawardedBadge() {
      return this.currentUser?.unawardedCredits > 0;
    },
    hasToShowGetCmeBtn() {
      return true;
    },
    hasToRenderNavigationDrawer() {
      return this.isFeedRoute || this.isTopicStateRoute;
    },
    hasToShowSpecialtyList() {
      if (this.showSpecialyListDialog) {
        if (this.$breakpoint.tabletAndUp) {
          this.setGeneralVeil(true);
        }

        document.querySelector(':root').classList.add('no-scroll');
        return true;
      }

      if (this.isFeedRoute) {
        // the previous call of setGeneralVeil without condition causes the DialogMobileComponent not work properly sinces set always back the veil to false
        // remember the LayoutComponent is always under the hood from many components and that includes its computed properties and watchers
        this.setGeneralVeil(false);
        document.querySelector(':root').classList.remove('no-scroll');
      }
      return false;
    },
    hasToShowFindArticlesImage() {
      return this.$vuetify.breakpoint.width >= 375;
    },
    isUserFreePlan() {
      return this.userSubscription?.stripeId == null || this.userSubscription?.status === 'canceled';
    },
    isFeedRoute() {
      return (
        this.isMainFeedRoute ||
        this.isPremiumCoursesFeedRoute ||
        this.isSpecialRequirementsFeedRoute ||
        this.isTopicStateRoute
      );
    },
    isTopicStateRoute() {
      return this.$route.name === 'special-requirements-topic-states';
    },
    isTopicStateFeedRoute() {
      return this.$route.name === 'special-requirements-topic-state-feed';
    },
    isMainFeedRoute() {
      return this.$route.name === 'home' || this.$route.name === 'main-feed-topic-states';
    },
    isPremiumCoursesFeedRoute() {
      return this.$route.name === 'premium-courses-feed';
    },
    isSpecialRequirementsFeedRoute() {
      return this.$route.name === 'special-requirements';
    },
    isEnabledPremiumCourses() {
      return process.env.VUE_APP_ENABLE_PREMIUM_COURSE === 'true';
    },
    hasToCenterContentToUpdateCard() {
      return this.$route.name === 'update-billing';
    },
    showExpirationAlert() {
      return this.willPaymentMethodExpire && this.routeIncludesExpirationAlert;
    },
    hasToShowGoToTopic() {
      return this.lastVisitedTopicState || this.hasSpecialRequirements;
    },
    routeIncludesExpirationAlert() {
      return ['transcripts', 'my-plan', 'profile', 'billing', 'home', '/'].includes(this.$route.name);
    },
    shouldShowTopBar() {
      if (this.isTopicStateRoute && this.isTopicStateFeedRoute && !this.currentUser) {
        return false;
      }

      return (
        !this.getHideAllMenu &&
        (!this.isFeedRoute || (this.$vuetify.breakpoint.width < 1264 && !this.getHideAllMenu) || this.currentUser)
      );
    },
    hasToShowOnboarding() {
      return (
        !this.isOnboardingFinished &&
        this.isOnboardingRequestDone &&
        this.currentUser &&
        (this.$route.path === 'home' || this.$route.path === '/')
      );
    },
    hasToShowRegisterUserOnboarding() {
      return this.hasToShowOnboarding && !this.currentUser.is_promo_user;
    },
    hasToShowPromoUserOnboarding() {
      return this.hasToShowOnboarding && this.currentUser.is_promo_user;
    },
    hasToFixBottomHelpLinks() {
      return this.$vuetify.breakpoint.height > 550;
    },
    isShowingPretestOnboarding() {
      if (this.isOnboardingPretestShow && this.currentUser) {
        this.setGeneralVeil(true);
        document.querySelector(':root').classList.add('no-scroll');
        return true;
      }

      return false;
    },
    calculateClassForTitle() {
      if (this.$breakpoint.smallMobileAndDown) {
        return 'heading-m-small onboarding-title-regular-mobile';
      }

      if (this.$breakpoint.mobileOnly) {
        return 'heading-l-large onboarding-title-regular-mobile mb-2';
      }

      return 'heading-m-large onboarding-title-regular-mobile';
    },
    titleForSteps() {
      return this.items[this.currentStepIndex].title;
    },
    hasToShowProBadge() {
      return false;
    },
    shouldShowCompleteProfileDialogOnTranscript() {
      return this.hasIncompleteProfile && this.$route.name === 'transcripts';
    },
    shouldShowCompleteProfileDialogOnProfile() {
      return this.hasIncompleteProfile && this.$route.name === 'profile';
    },
  },
  watch: {
    '$route.path': function () {
      this.currentRouteName = this.$route.name;
      this.currentRoutePath = this.$route.path;

      if (this.$route.name === 'home') {
        this.drawer = null;
        this.setIsFromFeedView(false);
        this.hideCreditsInNavBar(false);
      }
    },
    isLayoutPretest: {
      handler: function () {
        if (this.isLayoutPretest) {
          this.layoutBackground = 'layout-container-pretest';
          this.layoutMain = 'layout-main-pretest';
          this.navBarBackground = 'var(--v-grey-base)';
          return;
        }
        this.layoutBackground = 'layout-container';
        this.layoutMain = 'layout-main';
        this.navBarBackground = 'var(--v-background-base)';
      },
    },
    isShowPretestResult: {
      handler: function () {
        if (this.isShowPretestResult) {
          //I added this extra value, because for some reason the getCurrentReadingAtArticleId is empty in the third step
          this.currentArticleId = this.getCurrentReadingAtArticleId;
          this.currentStepIndex = this.enumOnboarding.THIRD_STEP;
          this.setGeneralVeil(true);
        }
      },
    },
  },
  async mounted() {
    this.currentRouteName = this.$route.name;
    this.currentRoutePath = this.$route.path;

    if (!this.currentUser) {
      this.loadSubscriptionDone();
      return;
    }

    const response = await this.getUserSubscription();
    if (response.data) {
      this.userSubscription = response.data;
      this.isFetchedUserSubscription = true;
    }

    if (this.userSubscription?.stripeId == null || this.userSubscription?.status === 'canceled') {
      this.setIsUserFreePlan(true);
      return;
    }
    this.setIsUserFreePlan(false);

    this.checkIfPaymentMethodWillExpire();
    this.finishInitLoad = true;
    if (this.isShowPretestResult) {
      this.currentStepIndex = this.enumOnboarding.THIRD_STEP;
      this.setGeneralVeil(true);
    }
  },
  updated() {
    if (this.$refs.onboardingPanelDisclosure && !this.touchEventsDone) {
      const that = this;
      this.$refs.onboardingPanelDisclosure.addEventListener(
        'touchstart',
        function (event) {
          that.touchstartY = event.changedTouches[0].screenY;
          that.touchstartX = event.changedTouches[0].screenX;
        },
        false,
      );

      this.$refs.onboardingPanelDisclosure.addEventListener(
        'touchend',
        function (event) {
          that.touchendY = event.changedTouches[0].screenY;
          that.touchendX = event.changedTouches[0].screenX;

          that.handleGestureDialogDisclosure();
        },
        false,
      );
      this.touchEventsDone = true;
    }

    if (this.$refs.descriptions && !this.mountedDone) {
      this.$refs.descriptions.addEventListener('animationend', () => {
        this.$refs.descriptions.className = this.descriptionClasses;
      });

      this.mountedDone = true;
    }
  },
  methods: {
    ...mapActions('profile', [
      'getProfile',
      'getUserPaymentMethod',
      'checkIfPaymentMethodWillExpire',
      'hideCompleteProfileDialog',
      'showCompleteProfileDialog',
    ]),
    ...mapActions('menu', [
      'hideTopMenu',
      'setTopMenuTitle',
      'setIsInternalRouting',
      'setGeneralVeil',
      'setIsReportCustom',
      'setIsReportOpen',
      'setIsFromFeedView',
      'hideCreditsInNavBar',
      'takeQuizButtonDisabledInNavBar',
    ]),
    ...mapActions('feed', [
      'layoutPretest',
      'showOnboardingPretest',
      'showPretestUser',
      'setArticleIdToPretest',
      'showPretestResult',
      'showPretestOnboarding',
      'hasToShowPretestOnboarding',
    ]),
    ...mapActions('subscriptions', ['getUserSubscription', 'setIsUserFreePlan', 'loadSubscriptionDone']),
    goToLogin() {
      this.$router.push({ name: 'login' });
    },
    goToSignup() {
      this.$router.push({ name: 'register' });
    },
    goToSpecialtiesList() {
      this.showSpecialyListDialog = true;
    },
    menuAction(id) {
      if (this.hasIncompleteProfile && id === 4) {
        this.showCompleteProfileDialog();
        return;
      }

      const selectedMenuItem = this.menuItemOptions.find((menuItemOption) => menuItemOption.id === id);
      if (!selectedMenuItem) {
        return;
      }

      const hasToScrollToTop = this.isFeedRoute && this.checkIfMenuIsActive({ routeName: selectedMenuItem.routeName });
      if (hasToScrollToTop) {
        document.documentElement.scrollTop = this.initial;
        return;
      }

      if (this.checkIfMenuIsActive(selectedMenuItem)) {
        return;
      }

      this.$router.push({ name: selectedMenuItem.routeName });
    },
    goBack() {
      const onRouteChanged = () => {
        this.hideCreditsInNavBar(false);
      };

      if (this.$route.name === 'article-pretest') {
        this.layoutPretest(false);
      }

      if (!this.getBackIfIsInternalRouting) {
        if (!this.getTitle) {
          this.$router.go(-1).then(onRouteChanged);
          return;
        }
        if (this.getTitle.toLowerCase() === 'back to quiz') {
          this.$router.push({ name: 'article-quiz', params: { id: this.$route.params.id } }).then(onRouteChanged);
        }
        if (this.getTitle.toLowerCase() === 'back to feed') {
          if (this.topicSlug && this.stateSlug) {
            this.$router
              .push({
                name: 'special-requirements-topic-state-feed',
                params: { topicSlug: this.topicSlug, stateSlug: this.stateSlug },
              })
              .then(onRouteChanged);
            return;
          }

          this.$router.push({ name: 'home' }).then(onRouteChanged);
        }
        if (this.getTitle.toLowerCase() === 'back to profile') {
          this.$router.push({ name: 'profile' }).then(onRouteChanged);
        }
        if (this.getTitle.toLowerCase() === 'back to personal info') {
          this.$router.push({ name: 'profile-info' }).then(onRouteChanged);
        }
        if (this.getTitle.toLowerCase() === 'back to billing') {
          this.$router.push({ name: 'billing' }).then(onRouteChanged);
        }
        if (this.getTitle.toLowerCase() === 'back to my plan') {
          this.$router.push({ name: 'my-plan' }).then(onRouteChanged);
        }
        if (this.getTitle.toLowerCase() === 'back to transcript') {
          this.$router.push({ name: 'transcripts' }).then(onRouteChanged);
        }
        if (this.getTitle.toLowerCase() === 'back to courses') {
          this.$router.push({ name: 'premium-courses-feed' }).then(onRouteChanged);
        }
        if (this.getTitle.toLowerCase() === 'back to topics') {
          this.$router.push({ name: 'special-requirements' }).then(onRouteChanged);
        }
        if (this.getTitle.toLowerCase() === 'back to topic') {
          const params = {
            topicSlug: this.topicSlug,
            stateSlug: this.stateSlug,
          };
          this.$router.push({ name: 'special-requirements-topic-state-feed', params }).then(onRouteChanged);
        }
        if (this.getTitle.toLowerCase() === 'back to overview') {
          if (this.hasSpecialRequirements) {
            this.$router
              .push({
                name: 'special-requirements-course-enrollment',
                params: {
                  topicSlug: this.topicSlug,
                  stateSlug: this.stateSlug,
                  courseId: this.$route.params.courseId,
                },
              })
              .then(onRouteChanged);
          } else {
            this.$router
              .push({ name: 'course-enrollment', params: { courseId: this.$route.params.courseId } })
              .then(onRouteChanged);
          }
        }
        if (this.isSpecialRequirementAbstractRoute) {
          if (this.isSpecialRequirementFileRoute) {
            this.$router
              .push({
                name: 'special-requirements-article-abstract',
              })
              .then(onRouteChanged);
            return;
          }

          this.$router
            .push({
              name: 'special-requirements-topic-state-feed',
              params: { topicSlug: this.topicSlug, stateSlug: this.stateSlug },
            })
            .then(onRouteChanged);
        }
      }

      if (this.getBackIfIsInternalRouting) {
        if (this.getIsReportCustom) {
          this.setIsReportCustom(false);
          return;
        }

        if (this.getIsReportOpen) {
          this.setIsReportOpen(false);
        }

        this.setIsInternalRouting(false);
      }
    },
    finishPreSelection() {
      this.setGeneralVeil(false);
      document.querySelector(':root').classList.remove('no-scroll');
      this.showSpecialyListDialog = false;
    },

    closeWelcome() {
      this.showSpecialyListDialog = false;
    },
    checkIfMenuIsActive({ routeName }) {
      const matchRoute = this.$route.name === routeName;
      if (!matchRoute) {
        return false;
      }

      return true;
    },
    handleClickFeedAsGuestUser() {
      const hasToScrollToTop = this.isMainFeedRoute;
      if (!hasToScrollToTop) {
        return;
      }

      this.scrollToTop();
    },
    handleClickPremiumCoursesAsGuestUser() {
      const hasToScrollToTop = this.isPremiumCoursesFeedRoute;
      if (!hasToScrollToTop) {
        return;
      }

      this.scrollToTop();
    },
    scrollToTop() {
      document.documentElement.scrollTop = this.initial;
    },
    skipOnboarding() {
      if (this.hasToShowGoToTopic) {
        const params = {
          topicSlug: this.lastVisitedTopicState?.topicSlug ?? this.topicSlug,
          stateSlug: this.lastVisitedTopicState?.stateSlug ?? this.stateSlug,
        };
        this.currentStepIndex = 0;
        this.showOnboardingPretest(false);
        document.querySelector(':root').classList.remove('no-scroll');
        this.setGeneralVeil(false);
        this.$router.push({ name: 'special-requirements-topic-state-feed', params });
      } else {
        if (this.currentStepIndex === this.enumOnboarding.THIRD_STEP) {
          this.showPretestResult(false);
        }

        this.currentStepIndex = 0;
        this.showOnboardingPretest(false);
        document.querySelector(':root').classList.remove('no-scroll');
        this.setGeneralVeil(false);
        if (this.$route.path !== '/') {
          this.$router.push({ name: 'home' });
        }
      }
    },
    getPrimaryButtonText() {
      if (this.$vuetify.breakpoint.width === 768 && this.currentStepIndex === this.enumOnboarding.THIRD_STEP) {
        return 'Read article & take quiz';
      }
      return this.items[this.currentStepIndex].btnPrimary;
    },
    getSecondaryButtonText() {
      if (this.hasToShowGoToTopic) {
        return 'Go to topic';
      }

      if (this.$vuetify.breakpoint.smOnly) {
        return 'Back to Feed';
      }
      return this.items[this.currentStepIndex].btnSecondary;
    },
    async nextStep() {
      if (this.currentStepIndex === this.enumOnboarding.SECOND_STEP) {
        if (this.noShowOnboarding) {
          this.showPretestOnboarding(false);
        }

        this.setGeneralVeil(false);
        this.showOnboardingPretest(false);
        document.querySelector(':root').classList.remove('no-scroll');
        this.$router.push({ name: 'article-pretest', params: { id: this.getCurrentReadingAtArticleId } });
        return;
      }

      if (this.currentStepIndex === this.enumOnboarding.THIRD_STEP) {
        this.currentStepIndex = 0;
        document.querySelector(':root').classList.remove('no-scroll');
        this.setGeneralVeil(false);
        this.showPretestResult(false);
        this.showOnboardingPretest(false);
        this.hideTopMenu(true);
        if (this.hasToShowGoToTopic) {
          this.setIsFromFeedView(false);
          this.setTopMenuTitle('Back to topic');
          this.$router.push({ name: 'special-requirements-article-pdf', params: { id: this.currentArticleId } });
        } else {
          this.setIsFromFeedView(true);
          this.setTopMenuTitle('Back to Feed');
          this.$router.push({ name: 'article-file-view', params: { id: this.currentArticleId } });
        }
        return;
      }

      this.currentStepIndex++;
      if (this.$refs.descriptions) {
        this.$refs.descriptions.className = `${this.descriptionClasses} ${this.animatedClass}`;
      }
    },
    goToStep(index) {
      this.currentStepIndex = index;
      if (this.$refs.descriptions) {
        this.$refs.descriptions.className = `${this.descriptionClasses} ${this.animatedClass}`;
      }
    },
    handleGestureDialogDisclosure() {
      const passThresholdToleranceDisclosure =
        Math.abs(this.touchendY - this.touchstartY) < 100 && Math.abs(this.touchendX - this.touchstartX) > 50;

      if (this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.smOnly) {
        if (this.touchendX < this.touchstartX && passThresholdToleranceDisclosure) {
          this.nextStep();
        }

        if (this.touchendX > this.touchstartX && passThresholdToleranceDisclosure) {
          this.goStepBack();
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
#logo-container {
  padding-right: 10px;
}

.layout-container {
  background-color: var(--v-background-base);
  height: auto !important;
  padding: 0px !important;
}
.layout-container-pretest {
  background-color: var(--v-grey-base);
  height: 100% !important;
  padding: 0px !important;
}

.layout-main {
  background-color: var(--v-background-base);
}

.layout-main-pretest {
  background-color: var(--v-grey-base);
}
.black-veil {
  width: 100%;
  // Patch, since found that in most bigger devices the veil doesnt cover all the area
  height: inherit;
  background-color: #000000;
  position: absolute;
  z-index: 9;
  opacity: 0.5;
}

.v-app-bar.v-app-bar--fixed {
  z-index: 3 !important;
}
.text.text-l-large-regular {
  font-size: 1rem !important;
}
#app-drawer {
  height: 100% !important;
}

.specialty-panel {
  position: fixed;
  background-color: var(--v-background-base);
  z-index: 99;
  box-shadow: 0px 14px 14px rgba(0, 0, 0, 0.07);
}

.specialty-panel p.descriptions {
  height: 72px;
}
.buttons-disposition-mobile {
  display: flex;
  flex-direction: column-reverse;
}
.fix-last-step-overflow {
  overflow-x: hidden;
}

.pro-chip {
  margin-left: 27px;
  height: 24px;
  width: 35px;
  padding: 0;
  padding-left: 8px;
}

.pro-chip-special-requirements {
  height: 24px;
  width: 53px;
  padding: 4px 8px;
  cursor: pointer;
}

.list-item-group-active {
  background-color: var(--v-primary-surface-base);
}

.center-content-update-card {
  text-align: -webkit-center !important;
}

/* 
  Remove default gray background color from v-list-item when active
  https://forum.vuejs.org/t/v-list-item-change-v-list-item-active-background-color-vuetify/112507/5 
*/
.theme--light.v-list-item--active:before,
.theme--light.v-list-item--active:hover:before,
.theme--light.v-list-item:focus:before {
  opacity: 0;
}
.menu-item {
  min-height: 56px;
}
.sidebar-border.v-navigation-drawer >>> .v-navigation-drawer__border {
  display: none;
}

.buttons-disposition-mobile {
  display: flex;
  flex-direction: column-reverse;
}
.onboarding-pretest-panel {
  position: fixed;
  background-color: var(--v-background-base);
  z-index: 99;
  box-shadow: 0px 14px 14px rgba(0, 0, 0, 0.07);
}
.right-side-onboarding {
  display: block;
}
.fix-last-step-overflow {
  overflow-x: hidden;
}
.adjust-images {
  display: flex;
  align-items: center !important;
  flex-direction: row-reverse;
}
.fixed-actions-nonmobile {
  position: absolute;
  z-index: 5;
  bottom: 0px;
  right: 0px;
  left: 0px;
}
@media (min-width: 600px) {
  .right-side-onboarding {
    position: relative;
  }
}
@media (max-width: 600px) {
  .onboarding-pretest-panel-size {
    width: 100%;
    height: 100%;
    top: 0;
  }
  .onboarding-pretest-panel-size > .row {
    background-color: var(--v-background-base);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .onboarding-pretest-panel-size {
    height: 27vh;
    min-height: 304px;
    width: 87.5%;
    left: 0;
    right: 0;
    margin: auto;
    top: calc(50% - 152px);
  }
}
@media (min-width: 1024px) and (max-width: 1263px) {
  .onboarding-pretest-panel-size {
    height: 268px;
    width: 75%;
    left: 0;
    right: 0;
    margin: auto;
    top: calc(50% - 152px);
  }
}
@media (min-width: 1264px) {
  .onboarding-pretest-panel-size {
    height: 25vh;
    min-height: 268px;
    width: 55%;
    max-width: 792px;
    left: 0;
    right: 0;
    margin: auto;
    top: calc(50% - 134px);
  }
}
@media (max-width: 320px) {
  .onboarding-title-regular-mobile {
    flex: 80%;
  }
  .pt-small-mobile {
    padding-top: 24px !important;
  }
}
@media (min-width: 321px) and (max-width: 600px) {
  .onboarding-title-regular-mobile {
    flex: 100%;
  }
  .number-step-box {
    width: 51px;
    height: 51px;
  }
  .no-show-again {
    margin-top: 4px !important;
  }
}

/* Default adjust for all generic non-portable devices */
@media (min-width: 600px) and (min-height: 600px) {
  .text-container {
    padding-top: 20px;
  }
  .first-step-nonmobile {
    padding-top: 8px;
  }
  .second-step-nonmobile {
    padding-top: 8px;
  }
}
/* Only tablets */
@media (min-width: 768px) and (min-height: 1024px) and (orientation: portrait) {
  .step-container {
    height: 135px !important;
  }
  .second-step-nonmobile {
    padding-top: 8px;
  }
  .stepButtoms {
    bottom: -64px;
  }
}
/* Regular small desktops */
@media (min-width: 1024px) and (min-height: 720px) and (orientation: landscape) {
  .step-container {
    height: 135px !important;
  }
  .second-step-nonmobile {
    padding-top: 8px;
  }
  .stepButtoms {
    bottom: -60px;
  }
}
.fixed-bottom-mobile {
  position: absolute;
  z-index: 5;
  width: calc(100vw - 48px);
  margin-left: 0;
  margin-right: 0;
  bottom: 24px;
}
.no-show-again {
  color: var(--v-grey-darken4) !important;
  margin-bottom: 8px;
}
.container-back {
  align-items: center;
  flex: min-content;
}
.fixed-back-text {
  width: 150px;
}
</style>
